import {BaseModel} from "./base-model";
import {Equipment} from "./equipment";
import {lookup as mimeLookup} from 'mime-types';
import {Utils} from "../utils";

export enum ResourceType {
  IMAGE,
  DOC,
  MODEL,
  VIDEO
}

export class ResourceUtils {

  public static get allResources() {
    return [ResourceType.IMAGE, ResourceType.DOC, ResourceType.MODEL, ResourceType.VIDEO];
  }

  public static ExtensionToResourceType(extension: string): ResourceType {
    const contentType: string = mimeLookup(extension) as string;
    switch (contentType.split('/')[0]) {
      case 'video':
        return ResourceType.VIDEO;
      case 'image':
        return ResourceType.IMAGE;
      case 'model':
        return ResourceType.MODEL;
      default:
        return ResourceType.DOC;
    }
  }

  public static ResourceTypesToContentType(resourceTypes: ResourceType[]): string {
    return resourceTypes.map(resourceType => {
      switch (resourceType) {
        case ResourceType.VIDEO:
          return ['mp4', 'webm', 'mov', 'avi'].map(extension => mimeLookup(extension)).join(',');
        case ResourceType.IMAGE:
          return ['png', 'jpg', 'gif', 'jpeg'].map(extension => mimeLookup(extension)).join(',');
        case ResourceType.MODEL:
          return ['glb', 'gltf'].map(extension => mimeLookup(extension)).join(',');
        case ResourceType.DOC:
          return ['pdf'].map(extension => mimeLookup(extension)).join(',');
      }
    }).join(',');
  }

  public static FileToContentType(file: File): string {
    return mimeLookup(Utils.getExtensionFromFile(file)) || '';
  }

  public static GetFileMetadata(file: File): { size: number, type: ResourceType } {
    const extension = Utils.getExtensionFromFile(file);
    const type = ResourceUtils.ExtensionToResourceType(extension);
    return { size: file.size, type };
  }

}

export class Resource extends BaseModel {

  protected self = Resource;

  id: string;
  name: string;
  equipmentModel: Equipment;
  modelId: string;
  type: ResourceType;
  typeId: ResourceType;
  extension: string;
  contentType: string;
  url: string;
  tags: string[];

  // TODO
  public validate(): boolean {
    return true;
  }

}
